import React, { useContext, useEffect, useState } from 'react'
import { StyledWorkPreference } from './styled'
import SimpleMemberLayout from 'spa/member/layouts/SimpleMemberLayout/Index'
import { useLoggedIn } from 'spa/member/hooks/useLoggedIn'
import { useLocation, useNavigate } from 'react-router'
import { Direction } from 'spa/member/components/WorkPreference/Registration/types'
import TagManager from 'react-gtm-module'
import { SessionContext } from 'spa/App'

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth'
  })
}

const Index: React.FC = () => {
  const [currentStep, setCurrentStep] = useState(1)
  const navigate = useNavigate()
  const location = useLocation()
  const loggedIn = useLoggedIn()
  const session = useContext(SessionContext)
  const [sending, setSending] = useState(false)

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const step = Number(params.get('step'))

    if (step && step >= 1 && step <= 4) {
      setCurrentStep(step)
    } else {
      setCurrentStep(1)
    }
  }, [location.search])

  useEffect(() => {
    if (!session?.user || currentStep !== 1) {
      return
    }

    TagManager.dataLayer({
      dataLayer: {
        occupationId: session.user.occupation_id,
        age: session.user.age,
        toApplyJobOfferId: session.to_apply_job_offer_id
      }
    })
  }, [session?.user])

  if (!loggedIn) {
    return null
  }

  const isLastStep = () => currentStep === 4

  const onSubmit = () => setSending(true)
  const onError = () => setSending(false)

  const onChangeStep = (direction: Direction) => {
    const params = new URLSearchParams(location.search)
    params.delete('step')

    if (isLastStep() && direction === 'next') {
      window.location.href = ['/user/registration/finish', params.toString()].filter(Boolean).join('?')
      return
    }

    const delta = direction === 'next' ? 1 : -1

    scrollToTop()

    params.set('step', String(currentStep + delta))

    setSending(false)
    navigate(`?${params}`)
  }

  return (
    <SimpleMemberLayout>
      <StyledWorkPreference currentStep={currentStep} onChangeStep={onChangeStep} sending={sending} onSubmit={onSubmit} onError={onError} />
    </SimpleMemberLayout>
  )
}

export default Index
